import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import AppLayout from '@/layouts/AppLayout.vue'
import LoginView from '@/views/auth/LoginView.vue'
import AdminListView from '@/views/admins/AdminListView.vue'
import AdminFormView from '@/views/admins/AdminFormView.vue'
import RolesListView from '@/views/roles/RolesListView.vue'
import RolesFormView from '@/views/roles/RolesFormView.vue'
import PermissionsListView from '@/views/permissions/PermissionsListView.vue'
import axios from 'axios';
import { initSocketListeners, isSocketListenersInitialized } from '@/services/socketListenerService';
import FaqListView from '@/views/faq/FaqListView.vue'
import FaqFormView from '@/views/faq/FaqFormView.vue'
import TutorialsListView from '@/views/tutorials/TutorialsListView.vue'
import TutorialsFormView from '@/views/tutorials/TutorialsFormView.vue'
import CategoriesAidesListView from '@/views/categories-aides/CategoriesAidesListView.vue'
import CategoriesAidesFormView from '@/views/categories-aides/CategoriesAidesFormView.vue'
import AccountUserView from '@/views/account/AccountUserView.vue'
import UsersListView from '@/views/users/UsersListView.vue'
import HomeView from '@/views/HomeView.vue'
import CollectivitesListView from '@/views/collectivites/collectivites/CollectivitesListView.vue'
import CollectivitesFormView from '@/views/collectivites/collectivites/CollectivitesFormView.vue'
import OnboardingView from '@/views/collectivites/onboarding/OnboardingView.vue'
import UsersDetailsView from '@/views/users/UsersDetailsView.vue'
import UsersFormView from '@/views/users/UsersFormView.vue'
import MarketCategoriesListView from '@/views/market/market-categories/MarketCategoriesListView.vue'
import MarketCategoriesFormView from '@/views/market/market-categories/MarketCategoriesFormView.vue'
import MarketFournisseursListView from '@/views/market/market-fournisseurs/MarketFournisseursListView.vue'
import MarketFournisseursFormView from '@/views/market/market-fournisseurs/MarketFournisseursFormView.vue'
import MarketProduitsListView from '@/views/market/market-produits/MarketProduitsListView.vue'
import MarketProduitsFormView from '@/views/market/market-produits/MarketProduitsFormView.vue'
import MarketAttributsListView from '@/views/market/market-attributs/MarketAttributsListView.vue'
import MarketAttributsFormView from '@/views/market/market-attributs/MarketAttributsFormView.vue'
import MarketProduitsStocksListView from '@/views/market/market-produits-stocks/MarketProduitsStocksListView.vue'
import MarketSettingsView from '@/views/market/MarketSettingsView.vue'
import MarketCommandesListView from '@/views/market/market-commandes/MarketCommandesListView.vue'
import MarketCommandesDetailsView from '@/views/market/market-commandes/MarketCommandesDetailsView.vue'
import UsersUtilisationView from '@/views/users/UsersUtilisationView.vue'
import UsersRevolvingView from '@/views/users/UsersRevolvingView.vue'
import UsersPlanView from '@/views/users/UsersPlanView.vue'
import UsersCarteView from '@/views/users/UsersCarteView.vue'
import CollectivitesDetailsView from '@/views/collectivites/collectivites/CollectivitesDetailsView.vue'
import ProspectsListView from '@/views/collectivites/prospects/ProspectsListView.vue'
import ServiceClientListView from '@/views/service-client/ServiceClientListView.vue'
import ServiceClientDetailView from '@/views/service-client/ServiceClientDetailView.vue'
import DashboardCollectiviteView from '@/views/collectivites/DashboardCollectiviteView.vue'
import OnboardingGroupeView from '@/views/collectivites/onboarding-groupe/OnboardingGroupeView.vue'
import FinancePrelevementsListView from '@/views/finance/FinancePrelevementsListView.vue'
import FinancePrelevementsDetailsView from '@/views/finance/FinancePrelevementsDetailsView.vue'
import FinanceDecaissementsListView from '@/views/finance/FinanceDecaissementsListView.vue'
import FinanceDecaissementsDetailsView from '@/views/finance/FinanceDecaissementsDetailsView.vue'
import CartesListView from '@/views/cartes/CartesListView.vue'
import CartesFormView from '@/views/cartes/CartesFormView.vue'
import FinanceAssetsView from '@/views/finance/FinanceAssetsView.vue'
import FinanceTransactionsView from '@/views/finance/FinanceTransactionsView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/app/dashboard'
  },
  {
    path: '/auth',
    children: [
      { path: "login", component: LoginView }
    ]
  },
  {
    path: '/app',
    component: AppLayout,
    meta: { requiresAuth: true },
    children: [
      // COMPTE UTILISATEUR
      { 
        path: "account", 
        component: AccountUserView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/auth/get_account_form_datas`)
            to.meta.form_datas = res.data;
            next();
          } catch (e) {
            next(false)
          }
        } 
      },
      // DASHBOARD
      { 
        path: "dashboard", 
        component: HomeView,
      },
      // MARKET / COMMANDES
      { 
        path: "market/market-commandes", 
        component: MarketCommandesListView,
      },
      { 
        path: "users/:id", 
        component: UsersDetailsView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/users/get/${to.params.id}`);
            to.meta.user = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }    
      },
      { 
        path: "market/market-commandes/:id", 
        component: MarketCommandesDetailsView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/market-commandes/get/${to.params.id}`);
            to.meta.commande = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }    
      },
      // MARKET / SETTINGS
      { 
        path: "market/market-settings", 
        component: MarketSettingsView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/market-settings/get_form_datas`)
            to.meta.form_datas = res.data;
            next();
          } catch (e) {
            next(false)
          }
        },
      },
      // MARKET / ATTRIBUTS
      { 
        path: "market/market-attributs/list", 
        component: MarketAttributsListView
      },
      { 
        path: "market/market-attributs/form", 
        component: MarketAttributsFormView
      },
      { 
        path: "market/market-attributs/form/:id", 
        component: MarketAttributsFormView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/market-attributs/get_form_datas`, { params: { id: to.params.id } })
            to.meta.form_datas = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }   
      },
      // MARKET / STOCKS
      { 
        path: "market/market-produits-stocks/list", 
        component: MarketProduitsStocksListView
      },
      // MARKET / PRODUITS
      { 
        path: "market/market-produits/list", 
        component: MarketProduitsListView
      },
      { 
        path: "market/market-produits/form", 
        component: MarketProduitsFormView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/market-produits/get_form_datas`)
            to.meta.form_datas = res.data;
            next();
          } catch (e) {
            next(false)
          }
        },
      },
      { 
        path: "market/market-produits/form/:id", 
        component: MarketProduitsFormView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/market-produits/get_form_datas`, { params: { id: to.params.id } })
            to.meta.form_datas = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }   
      },
      // MARKET / FOURNISSEURS
      { 
        path: "market/market-fournisseurs/list", 
        component: MarketFournisseursListView
      },
      { 
        path: "market/market-fournisseurs/form", 
        component: MarketFournisseursFormView,
      },
      { 
        path: "market/market-fournisseurs/form/:id", 
        component: MarketFournisseursFormView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/market-fournisseurs/get_form_datas`, { params: { id: to.params.id } })
            to.meta.form_datas = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }   
      },
      // MARKET / CATEGORIES
      { 
        path: "market/market-categories/list", 
        component: MarketCategoriesListView
      },
      { 
        path: "market/market-categories/form", 
        component: MarketCategoriesFormView,
      },
      { 
        path: "market/market-categories/form/:id", 
        component: MarketCategoriesFormView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/market-categories/get_form_datas`, { params: { id: to.params.id } })
            to.meta.form_datas = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }   
      },
      // COLLECTIVITES / DASHBOARD
      { 
        path: "collectivites/dashboard", 
        component: DashboardCollectiviteView
      },
      // COLLECTIVITES / ONBOARDING
      { 
        path: "collectivites/onboarding", 
        component: OnboardingView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/onboarding/get_form_datas`);
            to.meta.form_datas = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }   
      },
      // COLLECTIVITES / ONBOARDING GROUPE
      { 
        path: "collectivites/onboarding-groupe/:id", 
        component: OnboardingGroupeView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/collectivites/get_onboarding_groupe_form_datas/${to.params.id}`);
            to.meta.form_datas = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }   
      },
      // COLLECTIVITES / COLLECTIVITES
      { 
        path: "collectivites/list", 
        component: CollectivitesListView,  
      },
      { 
        path: "collectivites/form", 
        component: CollectivitesFormView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/collectivites/get_form_datas`)
            to.meta.form_datas = res.data;
            next();
          } catch (e) {
            next(false)
          }
        },
      },
      { 
        path: "collectivites/form/:id", 
        component: CollectivitesFormView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/collectivites/get_form_datas`, { params: { id: to.params.id } });
            to.meta.form_datas = res.data;
            next();
          } catch (e) {
            next(false)
          }
        },
      },
      { 
        path: "collectivites/:id/details", 
        component: CollectivitesDetailsView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/collectivites/get/${to.params.id}`);
            to.meta.item = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }    
      },
      // PROSPECTS
      { 
        path: "prospects/list", 
        component: ProspectsListView,
      },
      // COLLECTIVITES / MEMBRES
      { 
        path: "users/list", 
        component: UsersListView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/users/get_startupinfos_list_datas`, { params: { id: to.params.id } })
            to.meta.startupinfos_datas = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }    
      },
      { 
        path: "users/form/:id", 
        component: UsersFormView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/users/get_form_datas`, { params: { id: to.params.id } });
            to.meta.form_datas = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }    
      },
      { 
        path: "users/:id/details", 
        component: UsersDetailsView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/users/get/${to.params.id}`);
            to.meta.user = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }    
      },
      { 
        path: "users/:id/utilisation", 
        component: UsersUtilisationView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/users/get/${to.params.id}`);
            to.meta.user = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }    
      },
      { 
        path: "users/:id/revolving", 
        component: UsersRevolvingView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/users/get/${to.params.id}`);
            to.meta.user = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }    
      },
      { 
        path: "users/:id/plan", 
        component: UsersPlanView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/users/get/${to.params.id}`);
            to.meta.user = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }    
      },
      { 
        path: "users/:id/carte", 
        component: UsersCarteView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/users/get/${to.params.id}`);
            to.meta.user = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }    
      },
      // CARTE COOP FINANCE
      { 
        path: "cartes/list", 
        component: CartesListView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/cartes/get_startup_infos`);
            to.meta.startup_infos = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }
      },
      { 
        path: "cartes/form", 
        component: CartesFormView
      },
      // FINANCES
      { 
        path: "finance/assets", 
        component: FinanceAssetsView
      },
      { 
        path: "finance/prelevements", 
        component: FinancePrelevementsListView
      },
      { 
        path: "finance/prelevements/:id", 
        component: FinancePrelevementsDetailsView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/finance/prelevements/get_startup_infos/${to.params.id}`);
            to.meta.startup_infos = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }   
      },
      { 
        path: "finance/decaissements", 
        component: FinanceDecaissementsListView
      },
      { 
        path: "finance/decaissements/:id", 
        component: FinanceDecaissementsDetailsView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/finance/decaissements/get_decaissement_startup_infos/${to.params.id}`);
            to.meta.startup_infos = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }   
      },
      { 
        path: "finance/transactions", 
        component: FinanceTransactionsView
      },
      // CATEGORIES AIDES
      { path: "categories-aides/list", component: CategoriesAidesListView },
      { 
        path: "categories-aides/form/:id", 
        component: CategoriesAidesFormView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/categories-aides/get_form_datas`, { params: { id: to.params.id } })
            to.meta.form_datas = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }   
      },
      { path: "categories-aides/form", component: CategoriesAidesFormView },
      // TUTORIALS
      { path: "tutorials/list", component: TutorialsListView },
      { 
        path: "tutorials/form/:id", 
        component: TutorialsFormView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/tutoriels/get_form_datas`, { params: { id: to.params.id } })
            to.meta.form_datas = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }  
      },
      { 
        path: "tutorials/form", 
        component: TutorialsFormView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/tutoriels/get_form_datas`)
            to.meta.form_datas = res.data;
            next();
          } catch (e) {
            next(false)
          }
        } 
      },
      // FAQ
      { path: "faq/list", component: FaqListView },
      { 
        path: "faq/form/:id", 
        component: FaqFormView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/faq/get_form_datas`, { params: { id: to.params.id } })
            to.meta.form_datas = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }  
      },
      { 
        path: "faq/form", 
        component: FaqFormView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/faq/get_form_datas`)
            to.meta.form_datas = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }  
      },
      // ADMINS
      { path: "admins/list", component: AdminListView },
      { 
        path: "admins/form/:id", 
        component: AdminFormView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/admins/get_form_datas`, { params: { id: to.params.id } })
            to.meta.form_datas = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }  
      },
      { 
        path: "admins/form", 
        component: AdminFormView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/admins/get_form_datas`)
            to.meta.form_datas = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }  
      },

      // ROLES
      { path: "roles/list", component: RolesListView },
      { 
        path: 'roles/form/:id', 
        component: RolesFormView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/roles/get_form_datas`, { params: { id: to.params.id } })
            to.meta.form_params = res.data;
            next();
          } catch (e) {
            next(false)
          }
        } 
      },
      { 
        path: "roles/form", 
        component: RolesFormView,
        beforeEnter: async (to, from, next) => {
          try {
            const res = await axios.get(`/backoffice/roles/get_form_datas`)
            to.meta.form_params = res.data;
            next();
          } catch (e) {
            next(false)
          }
        }  
      },

      // PERMISSIONS
      { path: "permissions/list", component: PermissionsListView },

      // SERVICE CLIENT - Gestion des conversations de chat
      { path: "service-client", component: ServiceClientListView },
      { path: "service-client/:id", component: ServiceClientDetailView },
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// Guard global
router.beforeEach((to, from, next) => {
  const isLoggedIn = !!localStorage.getItem('LS_COOP_FINANCE_BO_ACCESS_TOKEN');

  if (to.meta.requiresAuth && !isLoggedIn) {
    next('/auth/login');
  } else {
    // Initialiser les listeners Socket.IO globaux dès que l'utilisateur est authentifié
    // Ceci permet de recevoir les notifications de nouveaux messages sur TOUTES les pages
    if (isLoggedIn && !isSocketListenersInitialized()) {
      console.log('[Router] Initialisation des listeners Socket.IO globaux...');
      initSocketListeners();
    }
    next();
  }
});

export default router
